export const INPUT_FORM_CLASS =
  'block w-full px-3.5 py-2.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white text-gray-900 dark:bg-gray-900 dark:text-gray-100 transition-all'

export const READONLY_INPUT_CLASS =
  'block w-full px-3.5 py-2.5 text-sm font-mono border border-dashed border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-900/40 text-gray-500 dark:text-gray-400 cursor-default focus:outline-none focus:ring-0'

export const CHECKBOX_CLASS =
  'w-4 h-4 text-primary-600 border-gray-300 dark:border-gray-600 rounded focus:ring-2 focus:ring-primary-500'

export const FORM_LABEL_CLASS = 'block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2'

export const FORM_ERROR_CLASS = 'mt-1.5 text-sm text-red-600 dark:text-red-400'

export const CARD_CLASS =
  'bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm'
